/* unplugin-vue-components disabled */import { render } from "./SelectVideo.vue?vue&type=template&id=09570efc&scoped=true"
import script from "./SelectVideo.vue?vue&type=script&lang=js"
export * from "./SelectVideo.vue?vue&type=script&lang=js"

import "./SelectVideo.vue?vue&type=style&index=0&id=09570efc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09570efc"]])

export default __exports__